import editor from './_editor';

// 期間の正規表現フォーマット
const REGEX = /20\d\d\/[0-1]\d\/[0-3]\d [0-2]\d:[0-5]\d/;

/**
 * 期間設定コンポーネント
 */
export default {
    template: '#period_component_template',
    props: {
        // 期間開始日
        start: {
            type: String,
            required: true,
        },
        // 期間終了日
        end: {
            type: String,
            required: true,
        },
        // 開始日の選択不可日設定データ
        start_disabled_dates: {
            type: Object,
            default: () => ({to: null, from: null}),
            required: false,
        },
        // 終了日の選択不可日設定データ
        end_disabled_dates: {
            type: Object,
            default: () => ({to: null, from: null}),
            required: false,
        },
        // 読み込み専用フラグ
        readonly: {
            type: Boolean,
            default: false,
        }
    },
    computed: {
        // ドロップダウン機能の有効化
        allowDropDown: function() {
            return (this.readonly) ? '' : 'dropdown';
        },
        // 編集中の期間開始日
        editStart:  {
            get() {
                return (this.validDate(this.start) ? this.start : '');
            },
            set(value) {
                value = this.adjustFormat(value);
                this.$emit('update-start', value);
                this.$forceUpdate();
            },
        },
        // 編集中の期間終了日
        editEnd:  {
            get() {
                return (this.validDate(this.end) ? this.end : '');
            },
            set(value) {
                value = this.adjustFormat(value);
                this.$emit('update-end', value);
                this.$forceUpdate();
            },
        },
        // 期間の設定に不備がある場合専用のCSSクラスを返す
        periodErrorClass: function () {
            let errerClass = {
                from: null,
                to: null
            };
            // どちらも入力されていない場合ははじく
            if (this.editStart.length == 0 && this.editEnd.length == 0) {
                return errerClass;
            }

            if (this.editStart.length != 0 && !REGEX.test(this.editStart)) {
                errerClass.from = 'format-error';
            }
            if (this.editEnd.length != 0 && !REGEX.test(this.editEnd)) {
                errerClass.to = 'format-error';
            }
            if (errerClass.from == null && errerClass.to == null) {
                // 期間の設定の開始日が終了日がより過去か否か
                if (!this.validDateRange(this.editStart, this.editEnd)) {
                    errerClass.to = 'period-errer';
                }
            }
            return errerClass;
        },
    },
    components: {
        // 期間編集コンポーネント
        'editor': editor
    },
    mounted: function () {
        // dropdownメニュー内をクリックしても閉じないようにする
        $('.period-edit-area').on('click.bs.dropdown.data-api', (event) => event.stopPropagation());
    },
    emits: [
        'update-start',
        'update-end',
        'click-readonly-input',
    ],
    methods: {
        /**
         * 日付の範囲チェック
         *
         * @param past 比較対象の時刻付き日付文字列(過去)
         * @param future 比較対象の時刻付き日付文字列(未来)
         */
        validDateRange: function (past, future) {
            // どちらかが空なら判定スキップ（true扱い）
            if (!past || !future) {
                return true;
            }
            // 日付形式が不正な場合:false
            if (!this.validDate(past) || !this.validDate(future)) {
                return false;
            }
            // past <= future の場合 true
            return new Date(past) <= new Date(future);
        },
        /**
         * 日付形式が正しいかチェック
         * @param datetime 時刻付き日付文字列
         * @return 形式不正の場合:false それ以外:true
         */
        validDate: function (datetime) {
            return Number.isInteger((new Date(datetime)).getTime());
        },
        /**
         * 日付形式を正しいフォーマットに調整する
         * @param value 入力された日時文字列
         * @return フォーマット調整後の文字列
         */
        adjustFormat: function (value) {
            return value
                .replace(/,+/g, ' ')
                .replace(/ +/g, ' ')
                .replace(/^ +| +$/g, '')
                .replace(/(\d{4})(\d{2})(\d{2})/, '$1/$2/$3')
                .replace(/(-|年|月)/g, '/')
                .replace(/：/g, ':')
                .replace(/　/g, ' ')
                .replace(/日/g, ' ')
                .replace(/(から|～|〜|~)/g, '')
                .replace(/(\(|（)(.*?)(\)|）)/, '')
                .replace(/(\/\d{1,2})( $|$)/, '$1 00:00')
                .replace(/(\/| )(\d)(\/| |:)/g, '$1' + '0$2$3');
        },

        // -------------------------
        // emit
        // -------------------------

        // 編集不可時、inputをクリックしたら親へ通知
        emitClickReadonlyInput: function () {
            if (this.readonly) {
                this.$emit('click-readonly-input');
            }
        }

    }
};
